export var docElement = document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/docElement.js
// module id = 491
// module chunks = 2